/**
 * El e-mail que el alta por WhatsApp inventa cuando la persona sólo dejó un teléfono.
 *
 * El backend lo arma como `<numero>@wppxcons.com` (`users.service.ts`, `autoEmail`) porque
 * `customer_entity` exige un e-mail para existir: es una clave técnica, no un dato de contacto.
 * Nadie lo lee, nadie lo escribe, y mostrarlo en el Admin invita a mandarle un mail a una casilla
 * que no existe.
 *
 * El nombre de la constante y el criterio son los mismos que usa el backend
 * (`SYNTHETIC_EMAIL_DOMAIN` en `contact-merge.service.ts`), a propósito: si el dominio cambia,
 * cambia en los dos lados con el mismo grep.
 */
export const SYNTHETIC_EMAIL_DOMAIN = "@wppxcons.com";

/** `true` si el e-mail es el placeholder del alta por WhatsApp y no una casilla real. */
export const isSyntheticEmail = (email?: string | null): boolean =>
  !!email && email.trim().toLowerCase().endsWith(SYNTHETIC_EMAIL_DOMAIN);

/**
 * El e-mail tal como se le muestra al operador: `""` si es el placeholder de WhatsApp.
 *
 * Se aplica **en el punto de render**, no sobre el dato: el valor crudo se sigue necesitando para
 * buscar (el número vive en la parte local del placeholder, así que tipearlo tiene que encontrar
 * a la persona) y para detectar el conflicto de identidad al guardar.
 *
 * Devuelve `""` en vez de `null` para que los `{email && …}` y los `email ? … : "-"` que ya
 * existen en las pantallas caigan solos a su rama de "sin dato", sin tocar cada condición.
 */
export const displayEmail = (email?: string | null): string =>
  isSyntheticEmail(email) ? "" : String(email ?? "");
